/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-30 13:05:30
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-06-30 13:05:30
 * @FilePath: /zeelool-nextjs/src/utils/shipping.ts
 * @Description: 运输方式相关工具函数
 */

/**
 * 根据运输方式名称获取显示文本
 * @param name 运输方式名称
 * @param timeMin 最小时间
 * @param timeMax 最大时间
 * @returns 显示文本
 */
export const getShippingMethodText = (
  name: string,
  timeMin?: number | string,
  timeMax?: number | string,
  globalT?: (key: string) => string, // 新增参数
): string => {
  const timeRange =
    timeMin && timeMax ? ` (${timeMin}-${timeMax} ${globalT('payment.ShippingMethod.days')})` : '';

  const methodMap: Record<string, string> = {
    ordinary: `${globalT('account.myOrders.orderDetail.ordinary')}${timeRange}`,
    advanced: `${globalT('account.myOrders.orderDetail.advanced')}${timeRange}`,
    business: `${globalT('account.myOrders.orderDetail.business')}${timeRange}`,
  };

  return methodMap[name] || name;
};

/**
 * 获取礼物状态文本
 * @param status 礼物状态码
 * @returns 状态文本
 */
export const getGiftStatusText = (status: number): string => {
  const statusMap: Record<string, string> = {
    '3': 'Limited Stock',
    '4': 'Sold Out',
  };
  return statusMap[status.toString()] || '';
};
